import React, { Fragment, useEffect } from "react";
import PropTypes from "prop-types";
import ResponsiveContentWrapper from "../../layout/ResponsiveContentWrapper";
import UserSearchInputWrapper from "../../Common/user/UserSearchInputWrapper";
import PhoneInput from "react-phone-input-2";
import Alert from "../../layout/Alert";
import { connect } from "react-redux";
import SearchUser from "../../dashboard/SearchUser";
import M from "materialize-css/dist/js/materialize.min.js";
import Grid from '@mui/material/Grid';
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { selectMenuProps } from "../../../utils/selectMenuProps";
import "../../Common/searchFilterLayout.css";

const UserSearchBar = (props) => {
  const user = props.user.user;
  useEffect(() => {
    M.AutoInit();
  }, []);
  return (
    <Fragment>
      <UserSearchInputWrapper onSubmitSuccess={props.onSubmitSuccess}>
        {({
          searchValue,
          searchBy,
          countryCode,
          onSubmit,
          setCountryCode,
          onSearchByChange,
          onSearchValueChange,
          showText = props.showText,
          allowedCountries,
        }) => {
          return (
            <ResponsiveContentWrapper>
              <div className="container">
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <div className="content-block bottom-shadow mb-0 search-filter-block search-filter-united-field">
                      <div className="p-15">
                        <div className="search-filter-filter">
                          <div className="search-filter-title">
                            <span className="black-text font-600">Search User</span>
                          </div>
                          <div className="search-filter-controls">
                            <span className="search-filter-search-by">Search By</span>
                            <FormControl variant="outlined" size="small" className="search-filter-type-select">
                              <Select
                                name="searchBy"
                                value={searchBy}
                                onChange={(e) => onSearchByChange(e)}
                                MenuProps={selectMenuProps}
                              >
                                <MenuItem value="mobile">Mobile No</MenuItem>
                                <MenuItem value="email">Email Id</MenuItem>
                              </Select>
                            </FormControl>
                            <form className="search-filter-form" onSubmit={onSubmit}>
                              <div className="search-filter-input-wrap">
                                <div className={searchBy === "mobile" ? "search-device not-found right no-left-pad" : "search-device not-found right"}>
                                  {searchBy === "mobile" ? (
                                    <PhoneInput
                                      enableSearch={false}
                                      value={countryCode}
                                      onChange={setCountryCode}
                                      containerClass="country-code-container"
                                      searchClass="country-code-search"
                                      dropdownClass="country-code-dropdown"
                                      onlyCountries={allowedCountries}
                                    />
                                  ) : (
                                    <i className="material-icons search-icon"> search</i>
                                  )}
                                  <input
                                    className="add-input notransform border-0"
                                    placeholder={
                                      searchBy === "mobile"
                                        ? "Mobile No Without Country Code"
                                        : "Enter Email Id"
                                    }
                                    type="text"
                                    name="text"
                                    value={searchValue}
                                    onChange={onSearchValueChange}
                                  />
                                </div>
                              </div>
                              <div className="search-filter-btn">
                                <input
                                  type="submit"
                                  value="Search"
                                  className="btn orange-bg btn-block md no-shadow"
                                />
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </div>
              <div>
                <Alert />
                {showText && user ? <SearchUser user={user} /> : null}
              </div>
            </ResponsiveContentWrapper>
          );
        }}
      </UserSearchInputWrapper>
    </Fragment>
  );
};

UserSearchBar.propTypes = {};

export default connect((state) => ({ user: state.user }))(UserSearchBar);
